import { useMutation, useQueryClient } from 'react-query';
import { fetchWorkflowData } from './useWorkflowDataQuery';
import { queryKeys } from './queryKeys';

interface MutationParams {
  clientId: string;
}

export const useWorkflowNavigateToMutation = ({ clientId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(fetchWorkflowData, {
    onSuccess(data) {
      queryClient.setQueryData(queryKeys.workflowData(clientId, data.Route.Params.pageId), data);
    },
  });
};
